import { Skeleton } from '@frontend-workspace/react-shared-lib';

export interface Props {
  isLoading: boolean
}

export function ContractsGridSkeleton(props: Props) {
  return (<>
    {props.isLoading && <>
      <div className='d-flex justify-content-end'>
        <Skeleton animation="wave" width={100} height={50} className='me-3' />
        <Skeleton animation="wave" width={150} height={50} />
      </div>
      <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
    </>}
  </>);
}

export default ContractsGridSkeleton;
